// 内置的过渡动画组件，需要单独引入
import CollapseTransition from "element-ui/lib/transitions/collapse-transition";

// 常规组件引入
import {
  Avatar,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Container,
  Header,
  Main,
  Button,
  Row,
  Divider,
  Table,
  TableColumn,
  Select,
  Option,
  Input,
  Col,
  MessageBox,
  Dialog,
  DatePicker,
  Form,
  FormItem,
  Radio,
  RadioGroup,
  Tag,
  Message,
  Pagination,
  Tooltip,
  Loading,
  Descriptions,
  DescriptionsItem,
  Checkbox,
  CheckboxGroup,
  Progress,
  Carousel,
  CarouselItem,
  Upload,
  Image,
  Tabs,
  TabPane,
  Card,
  Popover,
  Empty,
  Autocomplete,
  Rate,
} from "element-ui";

import "@/themes/index.scss";

import ElScrollBar from "element-ui/lib/scrollbar";

const element = {
  install: function (Vue) {
    Vue.use(DescriptionsItem);
    Vue.use(Dropdown);
    Vue.use(DropdownMenu);
    Vue.use(DropdownItem);
    Vue.use(Avatar);

    Vue.use(Descriptions);
    Vue.use(Container);
    Vue.use(Header);
    Vue.use(Main);
    Vue.use(Button);
    Vue.use(Row);
    Vue.use(Divider);
    Vue.use(Table);
    Vue.use(TableColumn);
    Vue.use(Select);
    Vue.use(Option);
    Vue.use(Input);
    Vue.use(Col);
    Vue.use(Dialog);
    Vue.use(DatePicker);
    Vue.use(Form);
    Vue.use(FormItem);
    Vue.use(Radio);
    Vue.use(RadioGroup);
    Vue.use(Tag);
    Vue.use(Pagination);
    Vue.use(Tooltip);
    Vue.use(Checkbox);
    Vue.use(CheckboxGroup);
    Vue.use(ElScrollBar);
    Vue.use(Loading.directive);
    Vue.use(Progress);
    Vue.use(Carousel);
    Vue.use(CarouselItem);
    Vue.use(Upload);
    Vue.use(Image);
    Vue.use(Tabs);
    Vue.use(TabPane);
    Vue.use(Card);
    Vue.use(Popover);
    Vue.use(Empty);
    Vue.use(Autocomplete);
    Vue.use(Rate);
    Vue.prototype.$confirm = MessageBox.confirm;
    Vue.prototype.$alert = MessageBox.alert;
    Vue.prototype.$msgbox = MessageBox.msgbox;
    Vue.prototype.$message = Message;

    Vue.component(CollapseTransition.name, CollapseTransition);
  },
};

export default element;
